import HBSwiper from "@/components/HBSwiper";
import Image from "@/components/Image";
import { TrackerA } from "@/components/Tracker";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import classNames from "classnames";
import styles from "./index.module.less";

export default function MaterialTopic({ className, data }) {
  return (
    <div className={classNames([styles.topic, className])}>
      <div className={styles.header}>
        <div className={styles.title}>{data?.name}</div>
      </div>
      <HBSwiper className={styles.list} iconClassName={styles.action}>
        <div className={styles.scroller}>
          {data?.list?.map((item) => (
            // eslint-disable-next-line react/jsx-no-target-blank
            <TrackerA
              className={styles.card}
              key={item.id}
              href={item.link}
              data-gd-click="topic_click"
              data-gd-expose="topic_expose"
              data-topic-type="一级主题"
              data-topic-id={item?.id}
              data-topic-title={item?.trackerTitle}
              data-content-source={data?.name}
              target="_blank"
              {...(item?.bgcolor ? { style: { color: item?.bgcolor } } : null)}
            >
              <div className={styles.container}>
                <div className={styles.img}>
                  <Image
                    {...gdImgSrcPolicy(item.banner_img_url, {
                      displayWidth: 164,
                      displayHeight: 280,
                      type: null,
                    })}
                    alt={item.title}
                  />
                </div>
                <div className={styles.content}>
                  <div className={styles.title}>{item.title}</div>
                </div>
              </div>
            </TrackerA>
          ))}
        </div>
      </HBSwiper>
    </div>
  );
}
